<template>
  <div class="member-wrapper">
    <div class='content'>
      <van-cell-group>
        <van-field v-validate="rules.account" clearable v-model.trim="account" name='account' @input='changeAccount' :error-message="errors.first('account')" autocomplete="off" placeholder="请输入账号" />
        <van-field v-model.trim="imageCode" name="imageCode" placeholder="图形验证码" autocomplete="off" clearable>
          <div slot="button" class="tCode pointer" v-loading="codeLoading" :style="{background: `url(${tCode}) center center / cover no-repeat`}" @click="changeTCode"></div>
        </van-field>
        <van-field v-validate="rules.code" clearable v-model.trim="code" name='code' :error-message="errors.first('code')" autocomplete="off" placeholder="请输入验证码">
          <vericode slot='button' :send-code='sendCode' :disable='imageCode.length !== 4' @send-code='handleSendCode'></vericode>
        </van-field>
        <van-field v-validate="rules.password" clearable type="password" v-model.trim="password" name='password' :error-message="errors.first('password')" autocomplete="off" placeholder="请输入密码" />
        <div class='tip' @click="toLogin">已有账号，去登录 》</div>
      </van-cell-group>
      <div class='btn-wrap'>
        <van-button type="primary" round size="large" :disabled="saveDisabled" @click='handleOk'>确定</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vericode from "@/components/member/vericode";
import md5 from 'js-md5';
import { Toast } from "vant";
export default {
  data () {
    return {
      imageCode: '',
      isMobile: false,
      vCode: '',
      codeLoading: false,
      tCode: '',
      guid: '',
      account: '',
      code: '',
      password: '',
      sendCode: false,
      disable: true,
      saveDisabled: false,
      scode: false,
      rules: {
        account: { required: true, formatAccount: true },
        code: { required: true, formatCode: true },
        password: { required: true, formatPassword: true }
      }
    }
  },
  watch: {
    scode: {
      handler (val, oldVal) {
        this.sendCode = val
      }
    }
  },
  methods: {
    changeAccount (val) {
      this.isMobile = val && !(val.indexOf('@') > -1) && !isNaN(val) && val.length === 11
      if (this.isMobile) {
        this.vCode = localStorage.getItem('VCode')
        this.guid = this.getGuid()
        this.tCode = this.vCode + 'imageid=' + this.guid
      }
    },

    changeTCode () {
      this.codeLoading = true
      this.tCode = this.vCode + 'imageid=' + this.guid + '&t=' + (new Date ()).getTime()
      this.codeLoading = false
    },

    getGuid () {
      function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }
      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },
    toLogin () {
      this.$router.push({ path: '/signIn', replace: true })
    },
    handleInput () {
      this.$validator.validate('account').then(result => {
        if (result) {
          this.disable = false
        }
      })
    },
    handleSendCode () {
      this.scode = true
      let params = {
        AppID: this.GLOBAL.AppID,//应用号:3:Erp2,12:在线提交3
        Method: 'GetVerifyCode',
        Account: this.account,//帐号:maxlength:100
        Type: 3,//验证码类型:1:注册,2:需要登录修改密码,3:无需登录修改密码,4:修改用户帐号 
        ImageID: this.isMobile ? this.guid : '',//图片编号:Type==1必填,Type==3必填
        ImageCode: this.isMobile ? this.imageCode : ''//图片验证码:Type==1必填,Type==3必填 
      }
      this.$Request(params)
    },
    handleOk () {
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '正在保存...',
            overlay: true
          });
          this.saveDisabled = true;
          let params = {
            AppID: this.GLOBAL.AppID, // 应用号
            Method: 'ResetPassword', // 接口名称
            Account: this.account, // 帐号
            Code: this.code,
            Password: md5(this.password).toUpperCase()
          }
          this.$Request(params).then(res => {
            Toast.clear();
            Toast.loading({
              type: "success",
              overlay: false,
              message: "设置成功",
              duration: 1000
            });
            setTimeout(() => {
              this.saveDisabled = false;
              this.$router.push({
                path: '/'
              })
            }, 1000)
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }
      });
    },
    //自定义字段验证
    validateField () {
      this.$validator.extend('formatAccount', {
        getMessage: field => "请输入正确的手机号或Email",
        validate: (value) => {
          return /^1\d{10}$/.test(value) || /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-z0-9_-]+)+$/.test(value)
        }
      });
      this.$validator.extend('formatCode', {
        getMessage: field => "请输入6位验证码",
        validate: (value) => {
          return /^([0-9]{6})$/.test(value)
        }
      });
      this.$validator.extend('formatPassword', {
        getMessage: field => "请输入6-20位字母数字组成密码",
        validate: (value) => {
          return /^([a-zA-Z0-9]{6,20})$/.test(value)
        }
      });
    },
  },
  mounted () {
    this.validateField();
  },
  components: {
    Vericode
  }
}
</script>
<style lang="less" scoped>
.tCode {
  width: 160px;
  height: 60px;
}

.pointer {
  cursor: pointer;
}
.content {
  padding: 20px 10px;
  .btn-wrap {
    text-align: center;
    margin: 100px auto;
  }
  .tip {
    color: #269cca;
    float: right;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.van-button--primary {
  color: #fff;
  background-color: #269cca;
  border: 0.02667rem solid #269cca;
}
</style>


// WEBPACK FOOTER //
// src/views/member/forget-pwd.vue